import enterprise from './enterprise/routes';
import smb from './smb/routes';
import campaign from './campaign/routes';

export default [enterprise, smb, campaign];
